// extracted by mini-css-extract-plugin
module.exports = {"textTitle":"wxrsdp","statsContainer":"cp-UZI","rateContainer":"eBkNhD","ratingContainer":"c_dluHt","rateNumber":"qb8OB0","rate":"c4BX3nW","total":"dkyY2m","ratingText":"YrMO4h"};